<template>
	<div id="x-header" ref="xHeader" @mouseenter.self="headerSlide($event,1)" @mouseleave.self="headerSlide($event,2)">
		<!--页头区域-->
		<div class="x-wrap-header">
			<div class="header-con">
				<div class="xhorse">
					<router-link :to="{path: '/index'}">
						<img class="xhorse-logo" :src="logo" alt="Xhorse"/>
					</router-link>
				</div>
				<div class="">
					<el-menu :default-active="String(activeTopIndex[0])"
							 class="el-x-menu"
							 mode="horizontal"
							 @select="onSelectChange"
							 :text-color="textColor"
							 :background-color="backColor">

						<!--关于我们-->

						<el-submenu index="1">
							<div class="slot-title"
								 slot="title" @click.captrue="onSelectChange('1-1',['1','1-1'])">
								About	Us
							</div>
							<el-menu-item index="1-1">
								<router-link to="">About Xhorse</router-link>
							</el-menu-item>
							<el-menu-item index="1-2">
								<router-link to="">Patents and Certificates</router-link>
							</el-menu-item>
							<el-menu-item index="1-3">
								<router-link to="">Business Structure</router-link>
							</el-menu-item>
							<el-menu-item index="1-4">
								<router-link to="">Extreme Horse Power</router-link>
							</el-menu-item>
							<el-menu-item index="1-5">
								<router-link to="">Employee</router-link>
							</el-menu-item>
							<el-menu-item index="1-6">
								<router-link to="">Responsibility</router-link>
							</el-menu-item>
							<el-menu-item index="1-7">
								<router-link to="">Address</router-link>
							</el-menu-item>
						</el-submenu>

						<!--解决方案-->

						<el-submenu index="2">
							<div class="slot-title"
								 slot="title" @click.captrue="onSelectChange('2-1',['2','2-1'])">
								Solutions
							</div>
							<el-menu-item index="2-1">
								<router-link to="">Key Cutting Machine Solutions</router-link>
							</el-menu-item>
							<el-menu-item index="2-2">
								<router-link to="">Professional Automotive Tools</router-link>
							</el-menu-item>
							<!--<el-submenu index="2-2">
								<div class="slot-title" slot="title"
									 @click.captrue="onSelectChange('2-2-1',['2','2-2','2-2-1'])">
									Professinal	Automative	Tools
								</div>
								<el-menu-item index="2-2-1">
									<router-link to="">VVDI Series</router-link>
								</el-menu-item>
								<el-menu-item index="2-2-2">
									<router-link to="">VVDI	Universal	Remote	Series</router-link>
								</el-menu-item>
							</el-submenu>-->
							<el-menu-item index="2-3">
								<router-link to="">IC	Programmers Solutions</router-link>
							</el-menu-item>
							<el-menu-item index="2-4">
								<router-link to="">Access Solutions</router-link>
							</el-menu-item>
							<el-menu-item index="2-5">
								<router-link to="">HPC Solutions</router-link>
							</el-menu-item>
							<el-menu-item index="2-6">
								<router-link to="">Customization	ASIC Solutions</router-link>
							</el-menu-item>
							<el-submenu index="2-7">
								<div class="slot-title" slot="title"
									 @click.captrue="onSelectChange('2-7-1',['2','2-7','2-7-1'])">
									Precision	Machinery	&	Motion	Control	Solutions
								</div>
								<el-menu-item index="2-7-1">
									<router-link to="">Desktop 5-axis engraving machine</router-link>
								</el-menu-item>
								<el-menu-item index="2-7-2">
									<router-link to="">5-axis Tool-sharpener</router-link>
								</el-menu-item>
								<el-menu-item index="2-7-3">
									<router-link to="">5-axis dental carving machine</router-link>
								</el-menu-item>
								<el-menu-item index="2-7-4">
									<router-link to="">6-axis robotic arm</router-link>
								</el-menu-item>
								<el-menu-item index="2-7-5">
									<router-link to="">Multi-axis motion test platform</router-link>
								</el-menu-item>
								<el-menu-item index="2-7-6">
									<router-link to="">Servo	System</router-link>
								</el-menu-item>
							</el-submenu>
							<!--<el-menu-item index="2-8">
								<router-link to="">Servo	System	Solutions</router-link>
							</el-menu-item>-->
							<el-submenu index="2-9">
								<div class="slot-title" slot="title"
									 @click.captrue="onSelectChange('2-9-1',['2','2-9','2-9-1'])">
									Optics	Measurement	&	Image	Recognition	Solutions
								</div>
								<el-menu-item index="2-9-1">
									<router-link to="">3D Scanner</router-link>
								</el-menu-item>
								<el-menu-item index="2-9-2">
									<router-link to="">Plane Measuring Instrument machine</router-link>
								</el-menu-item>
								<el-menu-item index="2-9-3">
									<router-link to="">Tool measuring instrument & tool measuring
										software
									</router-link>
								</el-menu-item>
								<el-menu-item index="2-9-4">
									<router-link to="">Optical key recognition tool</router-link>
								</el-menu-item>
								<el-menu-item index="2-9-5">
									<router-link to="">Three-dimensional Imaging</router-link>
								</el-menu-item>
								<el-menu-item index="2-9-6">
									<router-link to="">Binocular Vision</router-link>
								</el-menu-item>
								<el-menu-item index="2-9-7">
									<router-link to="">Intelligent Object Detection & Classification</router-link>
								</el-menu-item>
							</el-submenu>
							<el-submenu index="2-10">
								<div class="slot-title" slot="title"
									 @click.captrue="onSelectChange('2-10-1',['2','2-10','2-10-1'])">
									IME	Intelligent	Mechanical	Equipment	Solutions
								</div>
								<el-menu-item index="2-10-1">
									<router-link to="">Intelligent  Workshop</router-link>
								</el-menu-item>
								<el-menu-item index="2-10-2">
									<router-link to="">
										Intelligent  Automatic Complete Production Line
									</router-link>
								</el-menu-item>
								<el-menu-item index="2-10-3">
									<router-link to="">
										Ultra Short Pulse Laser Processing Technology and Integrated Equipment
									</router-link>
								</el-menu-item>
								<el-menu-item index="2-10-4">
									<router-link to="">Automatic Test Equipment  Solution</router-link>
								</el-menu-item>
							</el-submenu>
							<el-menu-item index="2-11">
								<router-link to="">System Level Machining Accuracy Assurance Solution</router-link>
							</el-menu-item>
							<el-submenu index="2-12">
								<div class="slot-title" slot="title"
									 @click.captrue="onSelectChange('2-12-1',['2','2-12','2-12-1'])">
									Intelligent	Process	Control Solution
								</div>
								<el-menu-item index="2-11-1">
									<router-link to="">MES（Manufacturing Execution System）</router-link>
								</el-menu-item>
								<el-menu-item index="2-11-2">
									<router-link to="">IEMS（Intelligent Equipment Management System）</router-link>
								</el-menu-item>
								<el-menu-item index="2-11-3">
									<router-link to="">FFDP（Fast Dashboard Player）</router-link>
								</el-menu-item>
							</el-submenu>
							<el-menu-item index="2-13">
								<router-link to="">Web Services - Industrial Internet of Things  Solution</router-link>
							</el-menu-item>
						</el-submenu>

						<!--新闻专区-->

						<el-submenu index="3">
							<div class="slot-title" slot="title"
								 @click.captrue="onSelectChange('3-1',['3','3-1'])">
								News
							</div>
							<el-menu-item index="3-1">
								<router-link to="">Going Global</router-link>
							</el-menu-item>
							<!--<el-menu-item index="3-2">
								<router-link to="">Exhibition	Info</router-link>
							</el-menu-item>
							<el-menu-item index="3-3">
								<router-link to="">Trends</router-link>
							</el-menu-item>-->
						</el-submenu>

						<!--技术支持-->

						<!--<el-submenu index="4">
							<template slot="title">Support</template>
							<el-submenu index="4-1">
								<template slot="title">Tech Support</template>
								<el-menu-item index="4-1-1">
									<router-link to="">Key Cutting Machine Series</router-link>
								</el-menu-item>
								<el-menu-item index="4-1-2">
									<router-link to="">Remote and Transponder</router-link>
								</el-menu-item>
							</el-submenu>
							<el-submenu index="4-2">
								<template slot="title">Tutorial	videos</template>
								<el-menu-item index="4-2-1">
									<router-link to="">Key Cutting Machine Series</router-link>
								</el-menu-item>
								<el-menu-item index="4-4-2">
									<router-link to="">KEY TOOL&MINI KEY TOOl</router-link>
								</el-menu-item>
								<el-menu-item index="4-4-3">
									<router-link to="">APP Functions</router-link>
								</el-menu-item>
								<el-menu-item index="4-4-4">
									<router-link to="">Remote and Transponder</router-link>
								</el-menu-item>
								<el-menu-item index="4-4-5">
									<router-link to="">KEY TOOL MAX</router-link>
								</el-menu-item>
								<el-menu-item index="4-4-6">
									<router-link to="">MINI OBD</router-link>
								</el-menu-item>
							</el-submenu>
						</el-submenu>-->

						<el-menu-item index="6" class="el-submenu header-el-menu-item">
							<div class="slot-title cur-slot-title" slot="title"
								 @click.captrue="onSelectChange('6',['6'])">
								<span class="block">
								Software
								</span>
								 Customization
							</div>
						</el-menu-item>

						<el-menu-item index="7" class="el-submenu header-el-menu-item">
							<div class="slot-title  cur-slot-title" slot="title"
								 @click.captrue="onSelectChange('7',['7'])">
								<span class="block">
								XhorseIM
								</span>
								(小马APP)
							</div>
						</el-menu-item>

						<el-menu-item index="8" class="el-submenu header-el-menu-item">
							<div class="slot-title  cur-slot-title" slot="title"
								 @click.captrue="onSelectChange('8',['8'])">
								 	<span class="block">
								Download
									</span>
								 Software
							</div>
						</el-menu-item>

						<!--加入我们-->

						<el-submenu index="5">
							<div class="slot-title" slot="title"
								 @click.captrue="onSelectChange('5-1',['5','5-1'])">
								Join Us
							</div>
							<el-menu-item index="5-1">
								<router-link to="">Why Choose Xhorse</router-link>
							</el-menu-item>
							<el-menu-item index="5-2">
								<router-link to="">Social Recruitment</router-link>
							</el-menu-item>
							<el-menu-item index="5-3">
								<router-link to="">Campus Recruitment</router-link>
							</el-menu-item>
						</el-submenu>
					</el-menu>
				</div>
				<div class="">
					<!--<ol class="h-lang" :style="{color: textColor}">
						<router-link to="">
							<li class="h-li">En</li>
						</router-link>
						<router-link to="">
							<li class="h-li x-sep">/</li>
						</router-link>
						<router-link to="">
							<li class="h-li">简</li>
						</router-link>
					</ol>-->
				</div>
			</div>
		</div>
		<!--页头区域-->
	</div>
</template>
<script>
    export default {
        name: 'x-header',
        props: ['path', 'backColor', 'textColor', 'activeTopIndex', 'activeSideIndex'],
        methods: {
            //当subMenu 点击时默认是第一页
            onSelectChange: function (index, indexPath) {
                const _this = this;
				/*console.log("onSelectChange", index, indexPath)*/
                _this.$emit('go', {type: 'top', val: indexPath});
            },
            headerSlide(event, state){
                const _this = this;
                if (["", "index"].indexOf(_this.$name) == -1) {
                    return;
                }
                const ele = event.target;
                if (state == 1) {
                    $(ele).css({
                        background: '#FFFFFF'
                    })
                    $(ele).find('*').not('.x-sub-menu,a,.el-submenu__icon-arrow').css({
                        color: '#2A2E2E',
                        background: '#FFFFFF'
                    })
                    _this.logo = _this.$logo_bk;
                } else {
                    $(ele).css({
                        background: 'transparent'
                    })
                    $(ele).find('*').css({
                        color: '#FFFFFF',
                        background: 'transparent'
                    })
                    _this.logo = _this.$logo_wh;
                }

				/* console.log("CHANGE")*/
            }
        },
        data: function () {
            const _this = this;
            return {
                logo: ["", "index"].indexOf(_this.$name) > -1 ? _this.$logo_wh : _this.$logo_bk,
            };
        },
        mounted() {

        },
        created(){
            const _this = this;
        }
    }
</script>
<style >
	@import '../../assets/css/header.css';

.cur-slot-title{
	line-height: 20px;
	}

.header-el-menu-item{
	height: 4.5rem !important;
	border: 0!important;
	display: flex;
	align-items: center;
	padding: 0 !important;
	justify-content: center;

}

.block{
	display: block;
	background-color:transparent !important;
}

.header-el-menu-item .slot-title{
	
}


</style>




// WEBPACK FOOTER //
// src/components/zh-cn/header.vue